import { observer } from "mobx-react";
import TaskCloneStore from "../../stores/task/task-clone";
import { useStore } from "../../stores/root-store";
import { Card, Checkbox, CheckboxChangeEvent, Flex, Tag, Image } from "antd";

const CloneCard: React.FC<{task: TaskCloneStore}> = ({task}) => {

    const { fileService } = useStore();

    const handleChangeIsClone = (event: CheckboxChangeEvent) => {
        task.toggleClone(event.target.checked);
    }

    return <Card title={`Задача ${task.data.id}`} className='card'
        extra={<Checkbox onChange={handleChangeIsClone} checked={task.isClone}>Это клон</Checkbox>}
    >
        <Card.Meta
            description={
                <div>
                    <Tag color="magenta">{task.data.theme?.name}</Tag>
                    <Tag color='green'>{task.data.source.name}</Tag>
                    <Tag color="cyan">Номер в КИМ {task.data.numberInKim?.name}</Tag>
                    {task.data.tags.map(tag => <Tag key={tag}>{tag}</Tag>)}
                </div>
            }
        />
        {task.data.photoIds &&
            <Flex wrap="wrap" gap="small" style={{ marginTop: "20px" }}>
                <Image.PreviewGroup >
                    <Image key={task.data.photoIds[0]} width={500} src={fileService.getFileUrl(task.data.photoIds[0])} />
                </Image.PreviewGroup>
            </Flex>
        }
    </Card>;
}

export default observer(CloneCard);